import * as React from "react";
const SvgBlueReceipt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      stroke="#466FF6"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M21 6.338v2.178c0 1.422-.9 2.322-2.322 2.322H15.6V4.547c0-1 .819-1.81 1.818-1.81a3.62 3.62 0 0 1 2.529 1.054A3.62 3.62 0 0 1 21 6.338"
    />
    <path
      stroke="#466FF6"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M3 7.238v12.6a.897.897 0 0 0 1.44.72l1.539-1.152a.91.91 0 0 1 1.188.09l1.494 1.503a.907.907 0 0 0 1.278 0l1.512-1.512a.89.89 0 0 1 1.17-.081l1.539 1.152c.594.44 1.44.018 1.44-.72v-15.3c0-.99.81-1.8 1.8-1.8H6.6c-2.7 0-3.6 1.61-3.6 3.6z"
    />
    <path
      stroke="#466FF6"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9.3 12.647H12M9.3 9.047H12M6.596 12.638h.008M6.596 9.038h.008"
    />
  </svg>
);
export default SvgBlueReceipt;
